/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, Ref, useState } from 'react';
import './styles/Popover.scss';

import { ClickAwayListener, Popper as MuiPopper, Stack, styled } from '@mui/material';

import { classNames, componentClassName } from '@dw/utils';

import { IModalPropsBase, Modal } from './Modal';
import { useScreenSize } from '@dw/hooks';

export interface IPopoverProps extends IModalPropsBase {
  anchorEl?: Element;
  maxWidth?: string;
  minWidth?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  noPadding?: boolean;
  children: React.ReactNode;
}
export const Popover: FunctionComponent<IPopoverProps> = (props: IPopoverProps) => {

  const {
    anchorEl,
    maxWidth,
    minWidth,
    children,
    placement,
    noPadding,
    ...modalBaseProps
  } = props;

  const { isMobile } = useScreenSize();

  const [arrowRef, setArrowRef] = useState<Ref<HTMLDivElement>>(null);

  const cn = componentClassName('popover');

  if (!anchorEl) {
    return null;
  } else if (isMobile) {
    return (
      <Modal
        {...modalBaseProps}
      >
        {children}
      </Modal>
    )
  }

  return (
    <ClickAwayListener onClickAway={modalBaseProps.onClose}>
      <MuiPopper
        open={modalBaseProps.open}
        placement={placement ?? 'right'}
        anchorEl={anchorEl}
        modifiers={[
          {
            name: 'flip',
            options: {
                altBoundary: false,
                fallbackPlacements: ['right', 'bottom', 'left', 'top'], // This is to prevent popper from being cut off at bottom or top, and just giving it the option to try to the left and right of the input as well
            }
          },
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              altAxis: true,
              altBoundary: true,
              tether: true,
              rootBoundary: 'document',
              padding: 8,
            },
          },
          {
            name: 'arrow',
            enabled: true,
            options: {
              element: arrowRef,
            },
          }
        ]}
        className={cn()}
      >
        <Stack maxWidth={maxWidth} minWidth={minWidth} className={classNames(cn('content'), {
          [cn('content', 'no-padding')]: noPadding
        })}>
          <Arrow ref={setArrowRef as any} className={cn('arrow')} />

          {children}
        </Stack>
      </MuiPopper>
    </ClickAwayListener>
  );
}

const Arrow = styled('div')({
  position: 'absolute',
  fontSize: 7,
  width: '3em',
  height: '3em',
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid',
  },
});